import type { StoredConnection } from './types'

export interface KeyValueStorage {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

const STORAGE_KEY = 'terminal-mcp.console.connection.v1'

function isStoredConnection(value: unknown): value is StoredConnection {
  if (!value || typeof value !== 'object') return false
  const item = value as Record<string, unknown>
  return (
    typeof item.origin === 'string' &&
    typeof item.deviceId === 'string' &&
    typeof item.clientId === 'string' &&
    typeof item.deviceLabel === 'string' &&
    typeof item.scope === 'string' &&
    typeof item.refreshToken === 'string' &&
    typeof item.pairedAt === 'number'
  )
}

export class BrowserCredentialVault {
  constructor(private readonly storage: KeyValueStorage = window.localStorage) {}

  load(): StoredConnection | null {
    const raw = this.storage.getItem(STORAGE_KEY)
    if (!raw) return null
    try {
      const value: unknown = JSON.parse(raw)
      if (!isStoredConnection(value)) {
        this.clear()
        return null
      }
      return value
    } catch {
      this.clear()
      return null
    }
  }

  save(connection: StoredConnection): void {
    // The one-time pairing secret and short-lived access token are deliberately absent.
    this.storage.setItem(STORAGE_KEY, JSON.stringify(connection))
  }

  clear(): void {
    this.storage.removeItem(STORAGE_KEY)
  }
}

export { STORAGE_KEY }
